import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';

// Import store
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import store from 'js/store/ConfigureStore';

// actions
import { startBootstrap } from 'js/store/bootstrap/Bootstrap.actions';

// import pages
import ErrorPage from 'js/page/Page.error';

/**
 * React additions
 */
import '../scss/styles.scss';
import 'overlayscrollbars/overlayscrollbars.css';

import App from 'js/App';
import { DOM_ID } from 'js/constants/App';

import { getBasePath } from 'js/utils/general';

const doRender = (Component = App, el) => {
  const persistor = persistStore(store);

  const onBeforeLift = () => {
    // Pause persistor - useful for delaying persistence until certain conditions are met
    // persistor.pause();
  };

  const root = createRoot(el);
  const routes = [
    {
      path: '/*',
      element: <App persistor={persistor} />,
      errorElement: <ErrorPage />,
    },
  ];

  const router = createBrowserRouter(routes, {
    basename: getBasePath(),
  });

  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor} onBeforeLift={onBeforeLift}>
        <RouterProvider router={router} fallbackElement={<div>FALLBACK</div>} />
      </PersistGate>
    </Provider>
  );
};

const mountApp = () => {
  const el = document.getElementById(DOM_ID);
  if (el === null) {
    console.error(`Dom node ${DOM_ID} is missing - aborting app`);
  } else {
    store.dispatch(startBootstrap());
    doRender(App, el);

    if (import.meta.hot) {
      import.meta.hot.accept();
    }
  }
};

if (window.cordova) {
  document.addEventListener('deviceready', mountApp, false);
} else {
  window.addEventListener('load', mountApp);
}
